export default "__VITE_ASSET__Bah2O2fo__"